import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  progressBarContainer: {
    width: '100%'
  },
  titleContent: {
    margin: '0 0 0.5em 0'
  },
  loadingMessageContent: {
    margin: '0.5em 0 0 0',
    fontSize: '1.1em'
  }
}));

const LoadingDialog = ({
  isOpen,
  loadingMessage = 'Loading'
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <div style={{ padding: '3em' }}>
        <div style={{ textAlign: 'center' }}>
          <h3 className={classes.titleContent}>Please wait...</h3>
        </div>
        <div className={classes.root}>
          <LinearProgress />
        </div>
        <div style={{ textAlign: 'center' }}>
          <p className={classes.loadingMessageContent}>{loadingMessage}</p>
        </div>
      </div>
    </Dialog>
  );
};

LoadingDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  loadingMessage: PropTypes.string
};

export default LoadingDialog;
